import React from "react";
import "./404.scss";
export var PageNotFound = function PageNotFound() {
  return /*#__PURE__*/React.createElement("div", {
    className: "not-found"
  }, /*#__PURE__*/React.createElement("h4", null, "Page not found"));
};
export default PageNotFound;